/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 9
// module chunks = 0